import ScrollReveal from "scrollreveal";

export default function initScrollReveal(targetElements, defaultProps) {
  const showEverything = () => document.documentElement.classList.remove("sr");
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (!targetElements.length || reduceMotion) {
    showEverything();
    return;
  }

  try {
    const sr = ScrollReveal({ reset: false });

    targetElements.forEach(({ element, animation }) => {
      sr.reveal(element, Object.assign({}, defaultProps, animation));
    });
  } catch (error) {
    showEverything();
  }
}
